import gql from 'graphql-tag';

const GET_RESOLUTIONS_BY_WORKSPACE_ID = gql`
  query MonitoringResolutions($workspaceId: ID!) {
    getMonitoringResolutionByWorkspaceId(workspaceId: $workspaceId) {
      monitoringResolutions {
        id
        workspaceId
        text
        isDefault
        custom {
          text
          id
        }
      }
    }
  }
`;

export default {
  GET_RESOLUTIONS_BY_WORKSPACE_ID,
};
